import { Form, Input, Modal, message } from "antd";
import { useLoading } from "../../context/loadingContext";
import ChangeMerchantPassword from "../../functions/merchant/changeMerchantPassword";
import { getMerchantId } from "service/storage";

const MerchantChangePasswordModal = ({ open, close }) => {
  const [form] = Form.useForm();
  const { showLoading, hideLoading } = useLoading();
  const merchantId = getMerchantId();

  const onFinish = async (values) => {
    if (values.newPassword !== values.confirmPassword) {
      message.error("Шинэ нууц үг таарахгүй байна");
      return;
    }
    showLoading();
    try {
      const response = await ChangeMerchantPassword(merchantId, {
        currentPassword: values.currentPassword,
        newPassword: values.newPassword,
      });
      if (response?.success) {
        message.success("Нууц үг шинэчлэгдлээ");
        form.resetFields();
        close();
      }
    } finally {
      hideLoading();
    }
  };

  return (
    <Modal
      title="Нууц үг солих"
      open={open}
      onCancel={close}
      onOk={() => form.submit()}
      okText="Хадгалах"
      cancelText="Болих"
      destroyOnClose
      width={440}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="currentPassword"
          label="Одоогийн нууц үг"
          rules={[{ required: true, message: "Одоогийн нууц үг оруулна уу" }]}
        >
          <Input.Password autoComplete="current-password" />
        </Form.Item>
        <Form.Item
          name="newPassword"
          label="Шинэ нууц үг"
          rules={[
            { required: true, message: "Шинэ нууц үг оруулна уу" },
            { min: 6, message: "Хамгийн багадаа 6 тэмдэгт" },
          ]}
        >
          <Input.Password autoComplete="new-password" />
        </Form.Item>
        <Form.Item
          name="confirmPassword"
          label="Шинэ нууц үг (давтах)"
          rules={[{ required: true, message: "Давтан оруулна уу" }]}
        >
          <Input.Password autoComplete="new-password" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default MerchantChangePasswordModal;
